import { render, staticRenderFns } from "./ButtonsGroup.vue?vue&type=template&id=c005d204&scoped=true"
import script from "./ButtonsGroup.vue?vue&type=script&lang=js"
export * from "./ButtonsGroup.vue?vue&type=script&lang=js"
import style0 from "./ButtonsGroup.vue?vue&type=style&index=0&id=c005d204&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c005d204",
  null
  
)

export default component.exports